<!-- 系统-设置 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea AddressSet">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="btnArea">
          <el-button class="btn" type="primary" @click="updateDialog('add')">添加</el-button>
        </div>
        <el-table :data="list" v-loading="loading">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="地址名称" prop="name"></el-table-column>
          <!-- <el-table-column label="地址类型" prop="env_type_name"></el-table-column> -->
          <el-table-column label="通讯地址" prop="mqtt_host"></el-table-column>
          <el-table-column label="4.0业务地址" prop="api_host_v4"></el-table-column>
          <el-table-column label="wms业务地址" prop="api_host_wms"></el-table-column>
          <el-table-column label="4.0s业务地址" prop="api_host_v4s"></el-table-column>
          <!-- <el-table-column label="本地地址" prop="execute_time"></el-table-column> -->
          <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="updateDialog('alter', scope.row)">修改</el-button>
              <el-button type="text" @click="deleteDialog(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 添加/修改 -->
        <el-dialog :title="updateTitle" :visible.sync="updateDio" width="500px">
          <el-form ref="updateForm" :rules="updateRules" :model="updateInfo" label-width="120px">
            <el-form-item prop="name" label="地址名称：">
              <el-input v-model="updateInfo.name"></el-input>
            </el-form-item>
            <el-form-item prop="mqtt_host" label="通讯地址：">
              <el-input v-model="updateInfo.mqtt_host"></el-input>
            </el-form-item>
            <el-form-item prop="api_host_v4" label="4.0业务地址：">
              <el-input v-model="updateInfo.api_host_v4"></el-input>
            </el-form-item>
            <el-form-item prop="api_host_wms" label="wms业务地址：">
              <el-input v-model="updateInfo.api_host_wms"></el-input>
            </el-form-item>
            <el-form-item prop="api_host_v4s" label="4.0s业务地址：">
              <el-input v-model="updateInfo.api_host_v4s"></el-input>
            </el-form-item>
            <el-form-item prop="remark" label="备注：">
              <el-input v-model="updateInfo.remark" type="textarea" :rows="4" placeholder="选填"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="updateDio = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('updateForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 删除 -->
        <el-dialog :visible.sync="deleteDio" width="500px">
          <p
            class="text">
            确认删除 
            <span class="bold">{{deleteInfo.name}}</span>
            ？
          </p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deleteDio = false">取 消</el-button>
            <el-button type="primary" @click="deleteServerEnv">确 定</el-button>
          </span>
        </el-dialog>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { showToast, deepCopy } from "../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../static/js/api.js"
  let vm

  export default {
    name: 'AddressSet',
    components: {
      BreadCrumb
    },
    data() {
      return {
        loading: false,
        list: [],

        // 添加/修改
        updateTitle: '',
        updateDio: false,
        updateInfo: {},
        updateRules: {
          name: [
            { required: true, message: '请输入地址名称', trigger: 'blur' },
          ],
        },

        // 删除
        deleteDio: false,
        deleteInfo: {}
      }
    },
    async created () {
      vm = this
      vm.getServerEnvList()
    },
    mounted(){
    },
    methods: {
      // 获取服务器环境列表
      async getServerEnvList () {
        let res = await systemApi.getServerEnvList()
        if (res.meta.code === 200) {
          // res.data.forEach((item, i)=>{
          //   let newItem = item
          //   newItem.env_type_name = item.env_type === '1' ? '正式环境' : '测试环境'
          //   vm.list.push(newItem)
          // })
          vm.list = [...res.data]
        } else {
          showToast(res.meta.message)
        }
      },
      // 添加/修改
      updateDialog (type, row) {
        if (type === 'alter') {
          vm.updateInfo = deepCopy(row)
        } else {
        // 重置添加参数
          vm.updateInfo = {
            name: '',
            mqtt_host: '',
            api_host_v4: '',
            api_host_wms: '',
            api_host_v4s: '',
            remark: ''
          }
        }
        vm.updateTitle = type === 'alter' ? '修改' : '添加'
        vm.updateDio = true
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            vm.updateServerEnv()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 新增/修改服务器环境
      async updateServerEnv () {
        let data = {
          name: vm.updateInfo.name,
          mqtt_host: vm.updateInfo.mqtt_host,
          api_host_v4: vm.updateInfo.api_host_v4,
          api_host_wms: vm.updateInfo.api_host_wms,
          api_host_v4s: vm.updateInfo.api_host_v4s,
          remark: vm.updateInfo.remark
        }
        if (vm.updateInfo.id) {
          data.id = vm.updateInfo.id
        }

        let res = await systemApi.updateServerEnv(data)
        if (res.meta.code === 200) {
          showToast(data.id ? '修改成功' : '添加成功')
          vm.updateDio = false
          vm.getServerEnvList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 删除
      deleteDialog (row) {
        vm.deleteInfo = deepCopy(row)
        vm.deleteDio = true
      },
      // 删除服务器环境
      async deleteServerEnv () {
        let data = {id: vm.deleteInfo.id}

        let res = await systemApi.deleteServerEnv(data)
        if (res.meta.code === 200) {
          showToast('删除成功')
          vm.deleteDio = false
          vm.getServerEnvList()
        } else {
          showToast(res.meta.message)
        }

      }
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Page/System/AddressSet.vue